import React, { useState } from 'react';
import MainContent from '../../components/MainContent';
import PageContainer from '../../components/PageContainer';
import BalanceSheetSummary from '../../components/Dashboard/BalanceSheetSummary';
import PageTitle from '../../components/Common/PageTitle/PageTitle';
import BalanceAccounts from '../../components/Dashboard/BalanceAccounts';
import ExpenseGraphs from '../../components/Dashboard/ExpenseGraphs';
import CounterStrip from '../../components/Dashboard/CounterStrip';
import RecentTransactions from '../../components/Dashboard/RecentTransactions';
import InvoiceReminder from '../../components/Dashboard/InvoiceReminder';
import LoanSummary from '../../components/Dashboard/LoanSummary';


const Dashboard = () => {
  
  return (
    <PageContainer>
            <MainContent>
                <PageTitle
                  title="Finance" 
                  description="Snapshot of your accounts status"
                  showsCompany
                  iconClass="fa fa-chart-line"
                  />

                <div className="row">
                    <div className="col-md-6">
                        <div className="row">
                          <BalanceSheetSummary />
                        </div>
                        <div className="row small-gutters">
                          <div className="col-md-12">
                            <ExpenseGraphs />
                          </div>
                        </div>
                        
                    </div>
                    <div className="col-md-6">
                      <div className="row">
                        <div className="col-md-7">
                          <BalanceAccounts />
                        </div>
                        <div className="col-md-5">
                          <InvoiceReminder />
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-12">
                          <LoanSummary />
                        </div>
                      </div>

                    </div>
                </div>
                
                
                <CounterStrip />
                <RecentTransactions />

            </MainContent>
            
    </PageContainer>
  );
};

export default Dashboard;
